<!--
 * @Description: 成品复检
 * @Author: wangwangwang
 * @Date: 2020-09-21 14:09:06
 * @LastEditors: wangwangwang
 * @LastEditTime: 2020-12-16 11:07:55
-->
<template>
  <SpecialCheckout type="2" typeId="4" />
</template>

<script>
import SpecialCheckout from './component/specialCheckout'
export default {
  components: {
    SpecialCheckout
  },
};
</script>
